import React from 'react'
import { t } from '../../../i18n/i18n'
import { tokens } from '@fluentui/react-components'
import { CostCategory, FinancialYearDashboardGraphDTO } from '../../../api/schemas/schema'
import { ResponsiveContainer, BarChart, XAxis, YAxis, CartesianGrid, Bar, LabelList, Legend } from 'recharts'
import { getRiskEconomyColors } from '../../../helpers/riskEconomyHelper'

type RiskEconomyCardGraphProps = {
   latestFinancialYears: FinancialYearDashboardGraphDTO[]
}
export const RiskEconomyCardGraph = ({ latestFinancialYears }: RiskEconomyCardGraphProps) => {
   const renderPercentageLabel = (props: any) => {
      const { x, y, width, height, value } = props
      const cx = x + width / 2
      const cy = y + height / 2

      const formattedPercentage = Number(value).toLocaleString('sv-SE', {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      })

      return (
         <g>
            <circle cx={cx} cy={cy} r={8} fill={tokens.colorStrokeFocus2} />
            <text x={cx} y={cy - 20} textAnchor="middle" fontSize={tokens.fontSizeBase500} fill={tokens.colorStrokeFocus2}>
               {formattedPercentage} %
            </text>
         </g>
      )
   }

   const CustomXAxisTick = (props: any) => {
      const { x, y, payload } = props

      return (
         <text x={x} y={y} dy={20} textAnchor="middle" fontSize={tokens.fontSizeBase400} fontWeight={tokens.fontWeightMedium}>
            {payload.value}
         </text>
      )
   }

   return (
      <>
         <ResponsiveContainer width="100%">
            <BarChart data={latestFinancialYears} margin={{ top: 25, right: 75, left: 0, bottom: 25 }} style={{ cursor: 'pointer' }}>
               <XAxis xAxisId={0} dataKey="name" tick={CustomXAxisTick} />
               <YAxis width={75} />
               <CartesianGrid vertical={false} strokeDasharray={'5 5'} />
               <Bar dataKey="damageCosts" stackId={'a'} xAxisId={0} fill={getRiskEconomyColors(CostCategory.DamageCosts)} barSize={150} />
               <Bar dataKey="preventiveCosts" stackId={'a'} xAxisId={0} fill={getRiskEconomyColors(CostCategory.PreventiveCosts)} barSize={150} />
               <Bar dataKey="insuranceCosts" stackId={'a'} xAxisId={0} fill={getRiskEconomyColors(CostCategory.InsuranceCosts)} barSize={150} />
               <Bar dataKey="securityAdministration" stackId={'a'} xAxisId={0} fill={getRiskEconomyColors(CostCategory.SecurityAdministration)} barSize={150}>
                  <LabelList dataKey="percentage" content={renderPercentageLabel} />
               </Bar>
               <Legend
                  verticalAlign="bottom"
                  iconType="square"
                  wrapperStyle={{
                     bottom: 10,
                  }}
                  align="center"
                  formatter={(value) => {
                     const text = value.toString().charAt(0).toUpperCase() + value.toString().slice(1)

                     return (
                        <span style={{ color: tokens.colorStrokeFocus2, fontSize: tokens.fontSizeBase300, padding: `0 ${tokens.spacingHorizontalM}` }}>
                           {t(text)}
                        </span>
                     )
                  }}
               />
            </BarChart>
         </ResponsiveContainer>
      </>
   )
}
